import { render } from "./index.vue?vue&type=template&id=c48a74c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c48a74c6&scoped=true&lang=less"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/3fa629ad-4e49-4135-b708-61865bcdea83/workspace/moon_eoR5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48a74c6"]])

export default __exports__